<template>
	<div class="time-selector type--sans type--s" v-click-outside="onBlur">
		<!-- Trigger -->
		<div @click.capture.stop="onOpen">
			<input
				type="text"
				class="input time-selector__selected"
				placeholder="Time"
				tabindex="-1"
				:disabled="disabled"
				:value="value"
				@click.self.prevent=""
			/>
		</div>
		<transition
			@before-enter="onBeforeEnter"
			@enter="onEnter"
			@before-leave="onBeforeLeave"
			@leave="onLeave"
			@after-leave="onAfterLeave"
		>
			<div class="time-selector__options" v-show="isOpen">
				<ul class="time-selector__list">
					<li
						v-for="(option, index) in options"
						:key="index"
						:class="[
							'time-selector__item',
							{'is-selected' : option === value}
						]"
						:ref="itemReference(option)"
						@click.prevent="updateValue(option)"
					>{{ option }}</li>
				</ul>
			</div>
		</transition>
	</div>
</template>

<script>
import TimeSeries from "@/utils/timeSeries"

export default {
	data() {
		return {
			value: null,
			options: null,
			isOpen: false
		}
	},

	name: "FlytTimeSelector",

	props: {
		disabled: {
			type: Boolean,
			default: false
		}
	},

	computed: {
		hasValue() {
			return this.value !== null
		}
	},

	methods: {
		reset() {
			this.value = null;
			this.isOpen = false;
		},
		onBeforeEnter(el) {
			el.style.opacity = 0
			el.style.transition = 'opacity'
			el.style.transitionDuration = '150ms'
			el.style.display = 'block'

			this.setScrollPosition(el)
		},

		onEnter(el) {
			el.style.opacity = 1
		},

		onBeforeLeave(el) {
			el.style.transition = 'opacity'
			el.style.transitionDuration = '150ms'
		},

		onLeave(el) {
			el.style.opacity = 0
		},

		onAfterLeave(el) {
			el.style.display = 'none'
		},

		onOpen(evt) {
			evt.srcElement.blur()
			this.isOpen = true
		},

		/**
		 * Scroll the list so that it is centred upon
		 * either midday (if no value is selected),
		 * or option matching the selected time.
		 */
		setScrollPosition(container) {
			const targetTop = this.hasValue
				? container.querySelector('.is-selected').offsetTop
				: container.querySelector('.time-selector__list').offsetHeight / 2
			const halfContainerHeight = container.offsetHeight / 2
			const halfItemHeight = container.querySelector('.time-selector__item').offsetHeight / 2

			container.scrollTop = targetTop - halfContainerHeight + halfItemHeight
		},

		onBlur() {
			this.isOpen = false
		},

		toggleIsOpen() {
			this.isOpen = !this.isOpen
		},

		updateValue(option) {
			this.value = option
			this.isOpen = false
			this.$emit("input", this.value)
		},

		itemReference(option) {
			return option === this.value
				? 'selected'
				: null
		}
	},

	mounted() {
		this.options = new TimeSeries({
			options: {
				hour: '2-digit',
				minute: '2-digit',
				hour12: false
			}
		})
	}
}
</script>

<style lang="scss" scoped>
// Non-scopeable elements
.time-selector {
	flex: 0 0 25%;
	line-height: 1;
	min-width: 3.5rem;

	/deep/ .vs__search {
		border-radius: 0 0.25rem 0.25rem 0;
		cursor: pointer;
		padding: 0.5rem 0.375rem;
	}

	/deep/ .vs__clear {
		display: none;
	}
}

.time-selector__options {
	background: #fff;
	border-radius: 0.25rem;
	box-shadow: $shadow-medium;
	cursor: pointer;
	overflow-x: hidden;
	overflow-y: scroll;
	-webkit-overflow-scrolling: touch;
	max-height: 15rem;
	min-width: 100%;
	position: absolute;
	right: 0;
	top: 50%;
	transform: translate(0, -50%);
	z-index: 10;
}

.time-selector__item {
	display: inline-block;
	padding: 0.625rem 0.75rem;
	width: 100%;
	&:hover {
		background: $colour-teal--bright;
	}
	&.is-selected {
		background: $colour-teal;
		color: #fff;
	}
}

.time-selector__selected {
	align-items: center;
	border-radius: 0 0.25rem 0.25rem 0;
	cursor: pointer;
	display: inline-flex;
	height: 3rem;
	justify-content: center;
	padding: 0 0.5rem;
	width: 100%;
	/deep/ & + input {
		// Hide input only when location-selector__selected appears directly before it
		display: none;
	}
}
</style>